import { FunctionComponent } from 'react';
import { LabelledInfoCell } from '../../../sharedComponents/sidebar/LabelledInfoCell';
import { CompoundLocation, ExpectedArrival } from '../../compoundManagement.types';
import { DateTimeInfo } from '../../shared/dataDisplay/DateTimeInfo';
import { DisplayCancellableData } from '../../shared/dataDisplay/DisplayCancellableData';
import { ArrivalCompletedForm } from '../../shared/sidebar/ArrivalCompletedForm';
import { DetailsRow } from '../../shared/sidebar/DetailsRow';
import { NoValue } from '../../../sharedComponents/NoValue';
import { AddressDetails } from '../../../sharedComponents/AddressDetails';
import { DisplayArrivalFreightForwarder } from '../../shared/dataDisplay/ArrivalDataContent';

export type ExpectedArrivalDetailsProps = {
    compoundVehicleId: string;
    arrival: ExpectedArrival;
    compoundLocation: CompoundLocation;
};

export const ExpectedArrivalDetails: FunctionComponent<ExpectedArrivalDetailsProps> = ({
    compoundVehicleId,
    arrival,
    compoundLocation,
}) => {
    const expectedArrivalAt = arrival.expectedArrivalAt;
    const isCancelled = arrival.isCancelled;

    return (
        <>
            <DetailsRow className="margin-bottom-15">
                <LabelledInfoCell labelMessageId="outboundOrderBook.common.heading.from">
                    <DisplayCancellableData isCancelled={isCancelled && arrival.arrivalFrom !== undefined}>
                        <AddressDetails
                            address={arrival.arrivalFrom?.address ?? {}}
                            identifier={arrival.arrivalFrom?.identifier}
                        />
                    </DisplayCancellableData>
                </LabelledInfoCell>
                <LabelledInfoCell labelMessageId="outboundOrderBook.compoundManagement.table.heading.expectedArrivalDate">
                    <DisplayCancellableData isCancelled={isCancelled}>
                        <DateTimeInfo date={expectedArrivalAt} timezone={compoundLocation.timeZone} />
                    </DisplayCancellableData>
                </LabelledInfoCell>
            </DetailsRow>
            <DetailsRow className="margin-bottom-15">
                <LabelledInfoCell labelMessageId="outboundOrderBook.compoundManagement.table.heading.carrier">
                    <DisplayArrivalFreightForwarder arrival={arrival} />
                </LabelledInfoCell>
                <LabelledInfoCell labelMessageId="outboundOrderBook.compoundManagement.table.heading.loadId">
                    {arrival.transportInformation.loadId ? (
                        <DisplayCancellableData isCancelled={arrival.isCancelled}>
                            {arrival.transportInformation.loadId}
                        </DisplayCancellableData>
                    ) : (
                        <NoValue />
                    )}
                </LabelledInfoCell>
            </DetailsRow>
            <ArrivalCompletedForm
                timeZone={compoundLocation.timeZone}
                compoundVehicleId={compoundVehicleId}
                disabled={isCancelled}
                arrivalCompletedAt={undefined}
                transportInformation={{
                    meansOfTransportType: arrival.transportInformation.meansOfTransportType,
                    meansOfTransportId: arrival.transportInformation.meansOfTransportId,
                    trailerId: arrival.transportInformation.trailerId,
                }}
            />
        </>
    );
};
